import React, { useState, useEffect } from 'react';
import {
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import Button from '../../components/CustomButtons/Button';
import { Delete } from '@material-ui/icons';
import axios from 'store/axios/axios-settings';
import { handleError } from '../../shared/utility';

const CSApproverManager = () => {
  const [csApprovers, setCsApprovers] = useState([]);
  const [form, setForm] = useState({ name: '', email: '', position: '' });
  const [deleteDialog, setDeleteDialog] = useState({ open: false, id: null });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleAdd = async () => {
    const { name, email, position } = form;
    if (!name || !email || !position) {
      alert('Please fill in all fields.');
      return;
    }

    try {
      const res = await axios.post('/cs_approver', {
        name,
        email,
        position,
      });

      const newEntry = {
        id: res.data.id || Date.now(), // Use returned ID or fallback
        name,
        email,
        position,
      };

      getCSApprovers();
      setForm({ name: '', email: '', position: '' });
    } catch (err) {
      console.error('Error adding CS Approver:', err);
      alert('Failed to add entry.');
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/cs_approver`, {
        params: { id },
      });

      getCSApprovers();
      setDeleteDialog({ open: false, id: null });
    } catch (err) {
      console.error('Error deleting CS Approver:', err);
      alert('Failed to delete entry.');
    }
  };

  const openDeleteDialog = (id) => {
    setDeleteDialog({ open: true, id });
  };

  const closeDeleteDialog = () => {
    setDeleteDialog({ open: false, id: null });
  };

  const getCSApprovers = async () => {
    try {
      const res = await axios.get('/cs_approvers');
      setCsApprovers(res.data);
    } catch(e) {
      handleError(e);
    }
  }

  useEffect(() => {
    getCSApprovers();
  }, []);

  return (
    <div style={{padding:20}}>
      <h2>CS Approver Manager</h2>

      <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
        <TextField
          label="Name"
          name="name"
          value={form.name}
          onChange={handleInputChange}
          size="small"
        />
        <TextField
          label="Email"
          name="email"
          value={form.email}
          onChange={handleInputChange}
          size="small"
        />
        <TextField
          label="Position"
          name="position"
          value={form.position}
          onChange={handleInputChange}
          size="small"
        />
        <Button onClick={handleAdd} color="primary">
          Add Approver
        </Button>
      </div>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Position</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {csApprovers.map((approver) => (
            <TableRow key={approver.id}>
              <TableCell>{approver.id}</TableCell>
              <TableCell>{approver.name}</TableCell>
              <TableCell>{approver.email}</TableCell>
              <TableCell>{approver.position}</TableCell>
              <TableCell>
                {csApprovers.length > 1 && <IconButton
                  onClick={() => openDeleteDialog(approver.id)}
                  color="error"
                >
                  <Delete />
                </IconButton>}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialog.open}
        onClose={closeDeleteDialog}
      >
        <DialogTitle>Delete Approver</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this CS Approver entry?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteDialog} color="primary">Cancel</Button>
          <Button
            color="error"
            onClick={() => handleDelete(deleteDialog.id)}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CSApproverManager;
